import { brandSecondary } from '../../styles/colors';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	button: {
		margin: '0 4px',
	},
	buttonContainer: {
		display: 'flex',
		marginBottom: 18,
		marginTop: 18,
	},
	container: {},
	content: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		maxWidth: 500,
	},
	title: {
		color: brandSecondary,
		fontSize: 18,
		marginBottom: 18,
		marginTop: 18,
	},
	warningText: {
		textAlign: 'center',
	},
});
